"use strict";

var _classCallCheck = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  result["default"] = mod;
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var PIXI = __importStar(require("pixi.js"));
var react_pixi_1 = require("@inlet/react-pixi");
var CanvasAlignmentViewportComponent_1 = require("./CanvasAlignmentViewportComponent");
var CanvasAlignmentHighlighterComponent_1 = require("./CanvasAlignmentHighlighterComponent");
var CanvasAlignmentTiledComponent_1 = require("./CanvasAlignmentTiledComponent");
var CanvasAlignmentComponent = /*#__PURE__*/function (_react_1$default$Comp) {
  _inherits(CanvasAlignmentComponent, _react_1$default$Comp);
  function CanvasAlignmentComponent(props) {
    var _this;
    _classCallCheck(this, CanvasAlignmentComponent);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(CanvasAlignmentComponent).call(this, props));
    _this.onMouseEnter = function (e) {
      //keep the scroll bars from appearing when the user is interacting with
      //the canvas. This fixes an issue where the canvas keeps moving around
      //due to appearince of the scroll bar in safari.
      document.body.style.overflow = "hidden";
    };
    _this.onMouseLeave = function (e) {
      document.body.style.overflow = "auto";
    };
    _this.onWheel = function (e) {
      //console.log("onWheel!", e);
      //e.preventDefault(); //TODO Drew is this necessary?
    };
    _this.state = {
      dragging: false
    };
    _this.divElement = react_1.default.createRef();
    return _this;
  }
  /**
   * Inform parent of the end of a drag event
   * @param newMousePosition
   */
  _createClass(CanvasAlignmentComponent, [{
    key: "informParentOfIndicatorDragged",
    value: function informParentOfIndicatorDragged(newMousePosition) {
      var _this$props = this.props,
        alignment = _this$props.alignment,
        onIndicatorDrag = _this$props.onIndicatorDrag;
      var dragPositions = this.state.dragPositions;
      if (onIndicatorDrag && dragPositions) {
        onIndicatorDrag({
          x: 0,
          y: Math.round(newMousePosition.y - dragPositions.startOffset.top),
          width: alignment.getMaxSequenceLength(),
          height: 0
        }, newMousePosition);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      if (!this.props.alignment) {
        return null;
      }
      var _this$props2 = this.props,
        alignment = _this$props2.alignment,
        alignmentType = _this$props2.alignmentType,
        colorScheme = _this$props2.colorScheme,
        highlightRows = _this$props2.highlightRows,
        onClick = _this$props2.onClick,
        positionsToStyle = _this$props2.positionsToStyle,
        sortBy = _this$props2.sortBy,
        stageDimensions = _this$props2.stageDimensions,
        viewportProps = _this$props2.viewportProps;
      var _this$state = this.state,
        dragging = _this$state.dragging,
        dragPositions = _this$state.dragPositions;
      var numSequences = alignment.getSequences().length;
      var maxSeqLength = alignment.getMaxSequenceLength();
      PIXI.utils.skipHello();
      PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.NEAREST; //
      //TODO: still anti-aliases on retina devices. probably requires
      //      writing 4x the pixels and telling pixi that it is a retina
      //      image
      //PIXI.settings.RESOLUTION = 2;
      //PIXI.settings.ROUND_PIXELS = true; //
      var rowHighlightStart;
      var rowHighlighterHeight;
      if (highlightRows) {
        rowHighlighterHeight = highlightRows.rowEnd - highlightRows.rowStart + 1; //why +1? start/end inclusive
        rowHighlightStart = dragging && dragPositions ? Math.round(dragPositions.current.y - dragPositions.startOffset.top) : highlightRows.rowStart;
        rowHighlightStart = rowHighlightStart > 0 ? rowHighlightStart : 0;
      }
      //const stageHeight =
      //  this.divElement.current && this.divElement.current.clientHeight // can be zero. this is kind of hacky
      //    ? this.divElement.current.clientHeight
      //    : stageDimensions?.height;
      var stageHeight = stageDimensions === null || stageDimensions === void 0 ? void 0 : stageDimensions.height;
      var stageWidth = stageDimensions === null || stageDimensions === void 0 ? void 0 : stageDimensions.width;
      return react_1.default.createElement("div", {
        className: "alignment-canvas",
        onWheel: this.onWheel,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        //style={{ width: stageWidth }}
        ref: this.divElement
      }, !this.divElement ? null : react_1.default.createElement(react_pixi_1.Stage, {
        width: stageWidth,
        height: stageHeight,
        options: {
          transparent: true
        }
      }, react_1.default.createElement(react_pixi_1.AppContext.Consumer, null, function (app) {
        _this2.app = app;
        return react_1.default.createElement(react_1.default.Fragment, null);
      }), react_1.default.createElement(react_pixi_1.AppContext.Consumer, null, function (app) {
        return react_1.default.createElement(CanvasAlignmentViewportComponent_1.CanvasAlignmentViewport, Object.assign({
          app: app,
          ensureVisible: rowHighlightStart === undefined || rowHighlighterHeight === undefined ? undefined : {
            y: rowHighlightStart,
            height: rowHighlighterHeight
          },
          numColumns: maxSeqLength,
          numRows: numSequences,
          onMouseClick: onClick,
          stageDimensions: stageDimensions
        }, viewportProps), react_1.default.createElement(CanvasAlignmentTiledComponent_1.CanvasAlignmentTiled, {
          alignment: alignment,
          alignmentType: alignmentType,
          sortBy: sortBy,
          colorScheme: colorScheme,
          positionsToStyle: positionsToStyle
        }), rowHighlightStart !== undefined && rowHighlighterHeight !== undefined && rowHighlighterHeight < alignment.getSequences().length ? react_1.default.createElement(CanvasAlignmentHighlighterComponent_1.CanvasAlignmentHighlighter, {
          fillColor: 0xff0000,
          fillAlpha: 0.25,
          x: 0,
          y: rowHighlightStart,
          width: maxSeqLength,
          height: rowHighlighterHeight,
          dragFunctions: {
            onDragStart: function onDragStart(e, parent) {
              var startPosition = e.data.getLocalPosition(parent);
              _this2.setState({
                dragging: true,
                dragPositions: {
                  startOffset: {
                    left: startPosition.x - 0,
                    top: startPosition.y - rowHighlightStart
                  },
                  current: startPosition
                }
              });
            },
            onDragEnd: function onDragEnd(e, parent) {
              _this2.setState({
                dragging: false
              });
              _this2.informParentOfIndicatorDragged(e.data.getLocalPosition(parent));
            },
            onDragMove: function onDragMove(e, parent) {
              if (dragging) {
                var newPosition = e.data.getLocalPosition(parent);
                _this2.setState({
                  dragPositions: {
                    startOffset: dragPositions.startOffset,
                    current: newPosition
                  }
                });
                _this2.informParentOfIndicatorDragged(newPosition);
              }
            }
          }
        }) : react_1.default.createElement(react_1.default.Fragment, null));
      })));
    }
  }]);
  return CanvasAlignmentComponent;
}(react_1.default.Component);
exports.CanvasAlignmentComponent = CanvasAlignmentComponent;
CanvasAlignmentComponent.defaultProps = {
  stageDimensions: {
    width: 485,
    height: 650
  }
};